'use client';
import styled from 'styled-components';

export const StyledDateTimeContainer = styled.div`
  width: ${props => props.width};
`;
